module.exports = __webpack_public_path__ + "media/images/static/guide/banner-522bf4d68ae785a690d242e86fd49be0.png";